module.exports = __webpack_public_path__ + "img/clement-tortoise.322e34da.png";